import Layout from "../../components/mainPage/Layout";
import SCCalculation from "../../images/systemComponents/SCCalculation.png";
export const Page = () => {
    return <Layout > 
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    Расчет токов короткого замыкания (ТКЗ)
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        <b>Расчет ТКЗ</b> на базе CIM (Common Information Model) в сочетании со SCADA NPT Expert, отвечающей за сбор данных и управление процессами,  становится важным инструментом для анализа энергосистем, который позволяет решать широкий спектр задач, связанных с проектированием, эксплуатацией и управлением энергосистемами.
                    </p>
                    <img
                        src={SCCalculation}
                        className="mb-4  w-100"
                        alt="Расчет токов короткого замыкания"
                    />

                    <p>Основные задачи, которые он позволяет решать, включают:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Оценка устойчивости и надежности энергосистемы</b>
                            <ul>
                                <li>Оперативный расчет токов КЗ в реальном времени по текущим данным от SCADA NPT Expert.                          </li>
                                <li>Определение максимальных и минимальных токов короткого замыкания в различных точках сети.</li>
                                <li>Анализ устойчивости энергосистемы при возникновении аварийных ситуаций.</li>
                                <li>Проверка соответствия параметров сети требованиям нормативных документов.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Выбор и настройка защитных устройств</b>
                            <ul>
                                <li>Расчет уставок для релейной защиты и автоматики (РЗА) на основе реальных данных о токах КЗ.</li>
                                <li>Оптимизация работы защитных устройств для минимизации времени отключения аварийных участков.</li>
                                <li>Проверка селективности срабатывания защит.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Проектирование и модернизация энергосистем</b>
                            <ul>
                                <li>Оценка необходимости модернизации оборудования (выключателей, трансформаторов, кабелей) с учетом токов КЗ.
                                </li>
                                <li>Проверка допустимости подключения новых потребителей или генерации к существующей сети.</li>
                                <li>Оптимизация конфигурации сети для снижения токов КЗ.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Планирование режимов работы энергосистемы</b>
                            <ul>
                                <li>Оценка влияния изменения конфигурации сети (включение/отключение линий, генераторов) на токи КЗ.
                                </li>
                                <li>Оптимизация режимов работы сети для снижения рисков возникновения КЗ.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </Layout>
}